import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import { scgcEnabled } from 'common/domain/helpers';
import { currentUserHasRight } from 'common/current_user';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { selectVisibility } from 'common/components/AssetBrowser/selectors/filters';

export const VisibilityFilter = () => {
  const visibility = useSelector(selectVisibility);
  const dispatch = useDispatch();

  const changeVisibility = (value) => {
    dispatch(filters.changeVisibility(value));
  };

  const scope = 'shared.asset_browser.filters.visibility';

  const visibilityOptions = [
    { label: I18n.t('options.all', { scope }), value: null },
    { label: I18n.t('options.public', { scope }), value: 'open' },
  ];

  if (scgcEnabled() && currentUserHasRight('can_view_internal_data')) {
    visibilityOptions.push({ label: I18n.t('options.internal', { scope }), value: 'site' });
  }

  visibilityOptions.push({ label: I18n.t('options.private', { scope }), value: 'internal' });

  const labelText = scgcEnabled() ? I18n.t('alternate_label', { scope }) : I18n.t('label', { scope });

  return (
    <div className="filter-section visibility">
      <label className="filter-label">{labelText}</label>
      <ForgeSelect
        name="visibility"
        value={visibility || null}
        variant="filled"
        onChange={(event) => changeVisibility(event.detail || null)}
        options={visibilityOptions}
      />
    </div>
  );
};

export default VisibilityFilter;
